import formattedMessage from "./formattedMessage";
import { whitelabelStore } from '../../packs/whitelabel'

function success(msg) {

  $.gritter.add({
    icon: whitelabelStore.iconSuccess,
    image: whitelabelStore.imageSuccess,
    title: 'Success',
    text: msg,
    sticky: false
  })
}

function alert(msg) {

  $.gritter.add({
    icon: whitelabelStore.iconWarning,
    image: whitelabelStore.imageWarning,
    title: 'Warning!',
    text: msg,
    sticky: false
  })
}

function fail(msg) {

  $.gritter.add({
    icon: whitelabelStore.iconFailure,
    image: whitelabelStore.imageFailure,
    title: 'Oops...',
    text: msg,
    sticky: false
  })
}

function newMessage(msg, conversation_id) {

  $.gritter.add({
    image: msg.sender.avatar,
    title: msg.sender.name,
    text: formattedMessage(msg),
    sticky: false,
    class_name: 'pointer round-avatar',
    on_click: (() => window.location.pathname = `/chat`)
  })
}

export default { success, alert, fail, newMessage }